export { default } from './ResponsiveHeaderImage'
